import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiEndPoint, StatusCode } from "../../services/helper";
import API from "../../services/api";
import { toast } from "react-toastify";
const initialState = {
  KitManagementData: [],
  PdfKitData: [],
  status: StatusCode.IDLE,
};
const {
  KITMANAGEMENT,
  CREATEBATCHKIT,
  CREATEMPTYKIT,
  START_BATCH_KIT,
  FETCH_PDF_DATA,
  DELETE_BATCH,
} = ApiEndPoint;
export const KitManagementSlice = createSlice({
  name: "Kitmanagement",
  initialState,
  reducers: {
    setPdfData: (state, action) => {
      state.PdfKitData = action.payload;
    },
    setKitManagementData: (state, action) => {
      state.KitManagementData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKitssManagementData.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchKitssManagementData.fulfilled, (state, action) => {
        state.KitManagementData = action.payload.data;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchKitssManagementData.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      .addCase(registerBatchKit.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(registerBatchKit.fulfilled, (state, action) => {
        state.status = StatusCode.IDLE;
      })
      .addCase(registerBatchKit.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      });
  },
});

export const { setPdfData, setKitManagementData } = KitManagementSlice.actions;
export default KitManagementSlice.reducer;

export const fetchKitssManagementData = createAsyncThunk(
  "admin/get/kit",
  async () => {
    try {
      const res = await API.get(KITMANAGEMENT);
      if (res.data?.status === 200) {
        return res.data;
      }
    } catch (error) {
      console.error("Failed to fetch product management data:", error);
      throw error;
    }
  }
);

// create batch kits

export const registerBatchKit = createAsyncThunk(
  "register/batch/kit",
  async (data) => {
    try {
      const res = await API.post(`${CREATEBATCHKIT}`, data);
      return res.data;
    } catch (error) {
      toast.error(error?.data?.message);
    }
  }
);

export const startBatchKitCreation = createAsyncThunk(
  "start/batch/kit/create",
  async (batchId) => {
    try {
      const res = await API.get(START_BATCH_KIT + batchId);
      if (res.data?.status === 200) {
        return res.data;
      }
    } catch (error) {
      console.error("Failed to fetch product management data:", error);
      throw error;
    }
  }
);

export const registerEmptyKit = createAsyncThunk(
  "create/empty/kit",
  async (data) => {
    try {
      const res = await API.post(`${CREATEMPTYKIT}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.status === 200) {
        toast.success(res.data?.message);
      }
      return res.data;
    } catch (error) {
      toast.error(error?.data?.message);
    }
  }
);

export const deleteKitManagementData = createAsyncThunk(
  "admin/delete/kit",
  async (data) => {
    try {
      const res = await API.delete(`${DELETE_BATCH}`, {
        ids: data?.ids,
      });
      if (res.status === 200) {
        toast.success(res?.data?.message);
        return data;
      }
    } catch (error) {
      toast.error(error.data?.message);
      throw error;
    }
  }
);

export const fetchBatchKitData = createAsyncThunk(
  "admin/fetch_pdf_data",
  async (id) => {
    try {
      const res = await API.post(`${FETCH_PDF_DATA}/${id}`);
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      toast.error(error.data?.message);
      throw error;
    }
  }
);
